module.exports = "/static-assets/_next/static/images/app-store-62ca10a5e055f88bded354a79236fa0a.svg";